import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class TeamReportsSection4Step5 extends PureComponent {
  get left_content() {
    const { sellingCosts } = this.props;

    return (
      <span>
        <u>Financial Impact of Your Decisions</u>
        <br />
        <br />
        Product Marketing decisions impact the following line items:
        <br />
        <br />- <b>Selling Costs:</b> Your Selling Costs of{" "}
        <AbbreviatedMillionNumberFormat
          value={sellingCosts}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        was driven by the costs to sell to the customer. These costs are mainly
        sales commissions that are paid to sales representatives and/or
        distributors.
        <br />
        <br />
        To learn more about what impacts these Operating Expenses, please review
        the following content:
        <br />
        <TypeformLink title="Marketing Mix" url={TypeformUrls.MARKETING_MIX} />
      </span>
    );
  }

  get right_content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Market Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection4Step5;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-4/step-5.js